module.exports = __webpack_public_path__ + "img/Marque-4.a28f8d0c.png";